const WEB_DEVICE_ID_KEY = 'ss_web_device_id';

const createDeviceId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `web-${crypto.randomUUID()}`;
  }
  return `web-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export const getStableWebDeviceId = () => {
  try {
    const existing = localStorage.getItem(WEB_DEVICE_ID_KEY);
    if (existing) return existing;
    const next = createDeviceId();
    localStorage.setItem(WEB_DEVICE_ID_KEY, next);
    return next;
  } catch {
    return createDeviceId();
  }
};

const getBrowserName = () => {
  const uaData = navigator.userAgentData;
  if (uaData?.brands?.length) {
    const primary = uaData.brands.find((b) => !/not.?a.?brand/i.test(b.brand));
    return primary?.brand || uaData.brands[0].brand;
  }

  const ua = navigator.userAgent;
  if (ua.includes('Edg/')) return 'Edge';
  if (ua.includes('Chrome/')) return 'Chrome';
  if (ua.includes('Firefox/')) return 'Firefox';
  if (ua.includes('Safari/')) return 'Safari';
  return 'Web Browser';
};

const getOsVersion = () => {
  const uaData = navigator.userAgentData;
  if (uaData?.platform) return uaData.platform;
  return navigator.platform || 'Unknown OS';
};

export const buildWebDeviceInfo = () => ({
  platform: 'web',
  deviceId: getStableWebDeviceId(),
  deviceModel: getBrowserName(),
  appVersion: process.env.REACT_APP_APP_VERSION || '1.0.0',
  osVersion: getOsVersion(),
});
